import { getErrorMessage } from "src/utils/form.utils";
import { Controller } from "react-hook-form";
import { IFormField } from "src/types/form.types"

type Props = IFormField & {
    errors: any;
    control: any
}

export const SelectField = ({
    label,
    name,
    options,
    disabled,
    autoFocus,
    control,
    errors,
}: Props) => {
    return (
        <>
            <label htmlFor={name} className="custom-label-field">
                {label}
            </label>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <select
                        {...field}
                        name={name}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        id={name}
                        className={`custom-input ${errors[name] ? "border-red-500" : ""}`}
                    >
                        {options?.map(({label,value})=>(
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </select>
                )}
            />
            {errors[name] && (
                <p
                    className={`mt-4 text-left text-sm ${errors[name] ? "text-red-500" : ""
                        }`}
                >
                    {getErrorMessage(errors[name].message,label)}
                </p>
            )}
        </>
    )
}